import { ReactNode, useState } from "react";
import "./ConcealableImageText.scss";
import cn from "classnames";
import {
  ButtonWithIcon,
  MinusCircleIcon,
  PlusCircleIcon,
} from "/App.Components";
interface Props {
  imageText: string;
  children?: ReactNode;
}

const ConcealableImageText = ({ imageText, children }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="image-text-norad">
      <div
        className={cn("image-text-norad__button", {
          "image-text-norad__button--top-position": !children,
        })}
      >
        <ButtonWithIcon
          icon={open ? MinusCircleIcon : PlusCircleIcon}
          iconPlacement={"after"}
          onClickHandler={() => setOpen(!open)}
          text="Bildetekst"
        />
      </div>
      {children && (
        <div className="image-text-norad__copyright">{children}</div>
      )}
      <div
        className={`image-text-norad__text image-text-norad__text${
          open ? "--open" : ""
        }`}
      >
        <p>{imageText}</p>
      </div>
    </div>
  );
};
export default ConcealableImageText;
